import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'
import ProductLogModal from '../../analytics/ProductLogModal'
import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {retrievePackage,getPackageData,setPackage,deletePackagetItem,editPackageItem,completeDirectPackage} from '../../../Redux/actions/packageActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'
import PackageDetail from '../PackageDetail'
import PackageSteps from '../PackageSteps'


const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({currentItem,onCloseModal,onCancelmodal}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data
    }), shallowEqual)


    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [modalWidth, setmodalWidth] = useState('80%')
    const [loading, setLoading] = useState(false)

    const [destination, setDestination] = useState(null)
    const [destinationName, setDestinationName] = useState(null)
    const [packItems, setPackItems] = useState([])

    const [allReceivedCounted, setAllRecieveCounted] = useState(false)    

    const [somethingChanged, setSomethingChanged] = useState(false)

    


    
    useEffect(() => {
      if(currentItem){
        setIsModalVisible(true)
        setPackItems(currentItem.items)
      }
    },[currentItem]);

    
    useEffect(() => {
      checkAllItemsReceived(packItems);


    },[packItems]);

    const cancelPackage = () =>{
      var packdata = { 
        status: 'cancelled',
        cancelled_at: moment().format('YYYY-MM-DD HH:mm:ss'),      
        cancelled_by:user.id,
        cancelled_name:user.name,  
      }
      setLoading(true)
      dispatch(setPackage(packdata,currentItem.id))
      .then(res=>{
        setLoading(false)
        setIsModalVisible(false);       
        onCloseModal()
      })
    }


    const completethisDirectPackage = async () =>{   
  
      setLoading(true)
      dispatch(retrievePackage(currentItem.id))
      .then(res=>{
        console.log(res)
        dispatch(completeDirectPackage(res))
        .then(resw=>{
          setLoading(false)
          setIsModalVisible(false);       
          onCloseModal()
        }).catch(err=>{
          setLoading(false)
          message.error('Package did not complete properly')
        })
      }).catch(err=>{
        setLoading(false)
        message.error('Package did not complete properly')
      })
   
    }

    const checkAllItemsReceived = (updatedPackItems) => {
      const allReceived = updatedPackItems.every(item => item.received_quantity !== undefined && item.received_quantity !== null);
      
      if (allReceived) {
          console.log("All packItems have received_quantity");
          setAllRecieveCounted(true)
          // Additional actions if needed when all items have received_quantity
      }else{
        setAllRecieveCounted(false)
        console.log("not all recieved counted");

      }
    }
        
    const footer = () =>{

      var schema= {
        title: 'Destination',
        key: 'destionation',
        type: 'options',   
        api:'locations', 
        prevent_recursion:true,
      }
      var current={
        id: user.branch
      }
  
      return(
        <div className="cartFooter"> 

          { (user.role == 'admin' || user.role == 'manager'|| user.role == 'oic') && (currentItem.status == 'shipping' && currentItem.is_direct) && allReceivedCounted ?
               <Popconfirm
               title="Are you sure to this count is correct?"
               onConfirm={()=>{completethisDirectPackage()}}        
               okText="Yes"
               cancelText="No"
             >  
               <Button type="primary" loading={loading}  >
                 Recieve Package
               </Button>  
             </Popconfirm>
           : null
          }
    
          { (user.role == 'admin' || user.role == 'manager'|| user.id == currentItem.created_by) && (currentItem.status == 'pending' || (currentItem.status == 'shipping' && currentItem.is_direct && (user.role == 'admin' || user.role == 'manager') ) ||currentItem.status == 'toPack' || currentItem.status == 'toShip' )?
            <Popconfirm
              title="Are you sure to delete this?"
              onConfirm={()=>{cancelPackage()}}        
              okText="Yes"
              cancelText="No"
            >  
              <Button type="danger" loading={loading}  >
                Cancel Package
              </Button>  
            </Popconfirm>
          : null}

     
        </div>
      )
     
    }

    
    const closeModal = () =>{
      if(!loading){
        setPackItems([])
        setIsModalVisible(false);       
        if(somethingChanged){
          onCloseModal()
          setSomethingChanged(false)
        }
      }
    }

    const deleteThis =(id) =>{
      setSomethingChanged(true)
      dispatch(deletePackagetItem(currentItem.id,id))
      .then(res=>{
        var newItems = packItems.filter(x => x.id !== id)
        setPackItems(newItems)
      })
    }

    const editItemQuantity = (item,id,qty) =>{

      var newdata={
        quantity: qty
      }

      if(user.role == 'warehouse' || user.role == 'oic' || user.role == 'manager' ){
        newdata={
          new_quantity: qty,
          new_quantity_to_approve: true,
          requested_at: moment().format('YYYY-MM-DD HH:mm:ss')    
        }
        if(qty == item.quantity){
          newdata={
            quantity: qty,
            new_quantity_to_approve: false
          }
        }
        
      }
      if(user.role == 'admin' || user.role == 'manager' ){
        if(item?.new_quantity_to_approve){
          if(item.new_quantity_to_approve == true){
            newdata={
              quantity: qty,
              new_quantity_to_approve: false
            }
          }
        }
        
        
      }
      console.log(newdata,currentItem.id,id)

  
      setSomethingChanged(true)
      dispatch(editPackageItem(newdata,currentItem.id,id))
      message.success('item quantity changed')
    }

    const editItemOrderedQuantity = (item,id,qty) =>{

      var newdata={
        ordered_quantity: qty,
        quantity: qty,
        admin_change_ordered_qty: moment().format('YYYY-MM-DD HH:mm:ss') 
      }
      if(currentItem.status == 'completed' &&  currentItem.is_direct ){
        newdata={        
          quantity: qty,
          received_quantity: qty,
          quantity_discrepancy: parseFloat(item.ordered_quantity) - parseFloat(qty),
          admin_change_ordered_qty: moment().format('YYYY-MM-DD HH:mm:ss') 
        }
      }

      setSomethingChanged(true)
      dispatch(editPackageItem(newdata,currentItem.id,id))
      message.success('item quantity changed')
    }

    const inputRecievedItemQuantity = (item,id,qty) =>{
     
      var newdata={
        received_quantity: qty
      }
      


      // Update the specific product's received_quantity
      const updatedPackItems = packItems.map(packItem => {
          if (packItem.id === id) {
              return {...packItem, received_quantity: qty};
          }
          return packItem;
        });

      // Update packItems state
      setPackItems(updatedPackItems);

  
      setSomethingChanged(true)
      dispatch(editPackageItem(newdata,currentItem.id,id))
      message.success('item quantity changed')
    }

    
    const approveItemQuantity = async (item,id) =>{

    
     
      var newdata={
        quantity:item. new_quantity
      }

      if(user.role == 'admin' || user.role == 'manager' ){
        if(item?.new_quantity_to_approve){
          if(item.new_quantity_to_approve == true){
            newdata={
              quantity: item.new_quantity,
              new_quantity_to_approve: false,
              approved_at: moment().format('YYYY-MM-DD HH:mm:ss')    
            }
          }
        }
        
        
      }
 

  
      setSomethingChanged(true)
      var appprv = await dispatch(editPackageItem(newdata,currentItem.id,id))
      message.success('item quantity changed')
    }


    const renderItemquantity = (currentItem,item) =>{ 

      var type = 1
      // 1 = show, 2 = edit, 3 = approve 4= direct shipping

      if((user.role == 'oic' || user.role == 'manager' ) && currentItem.status == 'pending' ){
        type = 2
      }

      if((user.role == 'warehouse' || user.role == 'manager' )&&  (currentItem.status == 'toPack' || currentItem.status == 'pending'  || currentItem.status == 'toShip'  )){
        type = 2
      }

      if((currentItem.status != 'completed' || currentItem.status != 'cancelled') && (user.role == 'admin' || user.role == 'manager') ){
        type = 2
      }
      
      if(currentItem.is_direct && currentItem.status == 'shipping' && (user.role == 'oic' || user.role == 'manager' || user.role == 'admin' ) ){
        type = 4
        if(user.role == 'manager' || user.role == 'admin' ){
          type = 5
        }
      }

      if( currentItem.status == 'completed' || currentItem.status == 'cancelled'){
        if( user.role == 'admin'){
          type = 5
        }else{
          type = 1
        }
       
      }

      var defaultval = item.quantity
      if(item?.new_quantity_to_approve){
        if(item.new_quantity_to_approve == true){
          defaultval = item.new_quantity
          if(type == 2 && (user.role == 'admin' || user.role == 'manager' )){
            type = 3
          } 
        }
      }

      if(type == 1){
        return(
          <div className="qtyItem minwidth">
            <h1>{item.quantity}</h1>
            <span>{item.unit}{item.quantity > 1 ? 's':''}</span>
        
          </div>
        )
      }

 
      if(type == 2){
        return(
          <div className="vertical minwidth">
          <InputNumber min={0} size={'large'} defaultValue={defaultval} onChange={(e)=>{editItemQuantity(item,item.id,e)}}  />
      

          <span>{item.unit}{item.quantity > 1 ? 's':''}</span>
        </div>
        )
      }

      if(type == 5){
        return(
          <div className="vertical minwidth">
          <InputNumber min={0} size={'large'} defaultValue={defaultval} onChange={(e)=>{editItemOrderedQuantity(item,item.id,e)}}  />
      

          <span>{item.unit}{item.quantity > 1 ? 's':''}</span>
        </div>
        )
      }

      if(type == 3){
        return(
          <div className="vertical minwidth">
          <InputNumber min={0} size={'large'} defaultValue={defaultval} onChange={(e)=>{editItemQuantity(item,item.id,e)}}  />
 
          
          <span>old qty: {item.quantity} {item.unit}{item.quantity > 1 ? 's':''}</span>
          <span>{item.unit}{item.quantity > 1 ? 's':''}</span>
        </div>
        )
      }


      if(type == 4){
        return(
          <div className="vertical minwidth">
          <InputNumber min={0} size={'large'} defaultValue={item.received_quantity ?? null}  onChange={(e)=>{inputRecievedItemQuantity(item,item.id,e)}}  />  
         
          <div className="vertical minwidth">
            <span>ordered qty:</span>


            <span>{item.quantity} {item.unit}{item.quantity > 1 ? 's':''}</span>

          </div>
        

        </div>
        )
      }
    
    
    }

  
  


    const approveLoop = async () =>{
      return Promise.all( packItems.map(item=>{
        if(item?.new_quantity_to_approve){
          if(item.new_quantity_to_approve == true){
            approveItemQuantity(item,item.id)
          }
        } 
      })
      )
    }

    const approveAllQtyChanges = () =>{
      setLoading(true)
  
      approveLoop()
      
      setLoading(false)
      setIsModalVisible(false);  
      onCloseModal()
    }

    const renderApproveAll = () =>{
      var turnyellow = false
      packItems.map(item=>{
        if(item?.new_quantity_to_approve){
          if(item.new_quantity_to_approve == true){
            turnyellow =true
          }
        } 
      })
      if(turnyellow && (user.role == 'admin' || user.role == 'manager')){
        return(
          <Button type='primary' loading={loading} onClick={()=>{approveAllQtyChanges()}}>
            Approve ALL Quantity Changes
          </Button>
        )
      }
   
    }

    return(       
      <>


      {isModalVisible?  
        <Modal title={currentItem ? currentItem.id :'Package'} className={'packagemodal'} visible={isModalVisible} footer={footer()} onCancel={()=>{closeModal();onCancelmodal()}} width={'720px'} >
          <div className="cart-content">
          <PackageDetail currentItem={currentItem} />
          <PackageSteps currentItem={currentItem} />
          <Divider orientation='left'> Items </Divider>
            {renderApproveAll()}
          <List
            className="demo-loadmore-list"   
            itemLayout="horizontal"
            dataSource={packItems}
            renderItem={item => {
              var userbranch = user.branch
              var error = false
              
              var branch ={
                id:currentItem.destination,
                name:currentItem.destination_name
              }
              var thisitem ={
                ...item,
                id: item.product,
                name:item.product_name
                
              }
              var turnyellow = false
              if(item?.new_quantity_to_approve){
                if(item.new_quantity_to_approve == true){
                  turnyellow =true
                }
              } 
              return(
                <List.Item
                  className={`listem ${turnyellow ? 'yellowbg' : '' }`}
                  actions={
               
             [    
                  <div className="vertical">
                    { 
                   (user.role == 'admin' || user.role == 'manager'  ||  (user.id == currentItem.created_by  && currentItem.status == 'pending') || (user.role == 'warehouse' && currentItem.status == 'pending' ) )?
                    <Button type='link' onClick={()=>{deleteThis(item.id)}}>
                      <DeleteOutlined  />
                    </Button> 
                    :null}
                    {turnyellow && (user.role =='admin' || user.role == 'manager') ?
                      <Button type='primary' onClick={()=>{approveItemQuantity(item,item.id)}}>
                          Approve
                      </Button>
                    :null}
                    </div>]
                  
                    
                  }
                >
         
                    <List.Item.Meta
                      avatar={
                        <ImageChecker                 
                          url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                          success={      
                            <img src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`} alt="image"   className={"prodimage"}/>                           
                          }
                          fail= {   <img src={`${process.env.REACT_APP_AWS_S3}logo.jpg`} alt="image"   className={"prodimage"}/>     }
                        />    
                      }
                      
                      title={       <ProductLogModal display={item.product_name} branch={branch} thisItem={thisitem} /> }
                      // description={                       
                  
                      // }   
                    />
                  {
                  renderItemquantity(currentItem,item)
                  }


                </List.Item>
              )}}
            />
            
          </div>
        </Modal>
        :null}
      </>
    )
}
  
export default Index
  